import { render } from "./StatisticsVerticalColumnChart.vue?vue&type=template&id=44c86336&scoped=true&ts=true"
import script from "./StatisticsVerticalColumnChart.vue?vue&type=script&lang=ts"
export * from "./StatisticsVerticalColumnChart.vue?vue&type=script&lang=ts"

import "./StatisticsVerticalColumnChart.vue?vue&type=style&index=0&id=44c86336&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c86336"]])

export default __exports__